import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import { MouseEvent } from "react";
import Proposal from "work/proposals/proposal";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import FeeScheduleTemplatesTable from "work/fee-schedule-templates/_views/tables/fee-schedule-templates-table";
import { Masked } from "work/_shared/masked-fields";

const FeeLink = styled(Link)(
  ({ theme }) => ({
    alignItems: "center",
    color: theme.palette.text.primary,
    cursor: "pointer",
    display: "flex",
    overflow: "hidden",
    textDecoration: "underline",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  })
);

type FeeScheduleLinkProps = {
  proposal: Proposal;
};

export default function FeeScheduleLink(props: Readonly<FeeScheduleLinkProps>) {
  const { proposal } = props;

  const { openDialog } = useDialog();

  function handleClick(event: MouseEvent) {
    if (Masked.isMasked(proposal.feeSchedule)) {
      throw new Error("Cannot view masked fee schedule");
    }
    event.stopPropagation();
    const viewFeeScheduleComponent = (
      <FeeScheduleTemplatesTable
        hideActionsColumn={true}
        hideCommentButton={true}
        selectedCategories={proposal.feeSchedule}
        disableEditing={true}
        disableCategorySelection={true}
        commentsToolTip={""}
      />
    );

    openDialog({
      component: viewFeeScheduleComponent,
      title: "Fee Schedule",
      MuiProps: {
        maxWidth: "lg",
      },
    });
  }

  if (!proposal.feeSchedule) return null;
  if (Masked.isMasked(proposal.feeSchedule)) {
    return <span>(masked)</span>;
  }
  return (
    <FeeLink onClick={handleClick}>
      View
    </FeeLink>
  );
}
